import React from 'react';
import Immutable from 'immutable';
import { cx } from '@milanote/roma/utils';
import { Menu, MenuSize } from '@milanote/roma';
import { GridListItem } from 'react-aria-components';
import ListItemBoardIcon from '../../../popupPanel/listItems/ListItemBoardIcon';
import { getRootBoardProperty } from '../../../../../common/elements/utils/elementPropertyUtils';
import type { BoardLinkListBaseProps, BoardLinkSearchItem } from './boardLinkTypes';

export type BoardLinkItemProps = BoardLinkListBaseProps & {
    item: BoardLinkSearchItem;
    size?: MenuSize;
};

const BoardLinkListItem: React.FC<BoardLinkItemProps> = ({ item, gridSize, onSelect, isSheet, size = 'sm' }) => {
    const isRootBoard = getRootBoardProperty(item.board);

    return (
        <GridListItem
            id={item.boardId}
            textValue={item.title}
            onAction={() => onSelect(item)}
            className={cx('BoardLinkListItem w-full outline-hidden', 'py-0.5')}
        >
            {(state) => (
                <Menu.Base.ItemStructured
                    leading={
                        <span
                            aria-hidden="true"
                            className={cx(
                                'inline-flex shrink-0 items-center justify-center',
                                isRootBoard && 'p-0.5 [&_.MilanoteLogo_svg]:!size-full',
                            )}
                        >
                            <ListItemBoardIcon element={Immutable.fromJS(item.board)} size={4} gridSize={gridSize} />
                        </span>
                    }
                    label={<span className="font-bold text-inherit">{item.title}</span>}
                    isSelected={false}
                    isDisabled={state.isDisabled}
                    isFocused={state.isFocused}
                    isFocusVisible={state.isFocusVisible}
                    isHovered={isSheet ? false : state.isHovered}
                    className={cx('cursor-pointer', size == 'sm' ? 'mx-0.5' : '')}
                    size={size}
                />
            )}
        </GridListItem>
    );
};

export default BoardLinkListItem;
